import { AbsatzPlan } from './absatz';
import { UmsatzPlan } from './umsatz';

export class Planwert {
  constructor({
    datum,
    interneNotiz,
    umsatzPlan,
    absatzPlan,
  }: {
    readonly datum: string;
    readonly absatzPlan: AbsatzPlan;

    readonly umsatzPlan: UmsatzPlan;
    readonly interneNotiz: string;
  }) {
    this.datum = datum;
    this.absatzPlan = absatzPlan;
    this.umsatzPlan = umsatzPlan;
    this.interneNotiz = interneNotiz;
  }

  readonly datum: string;
  readonly absatzPlan: AbsatzPlan;
  readonly umsatzPlan: UmsatzPlan;
  readonly interneNotiz: string;
}
